import BackButton from "app/components/BackButton/BackButton";
import { ResponsiveScreenSizes } from "app/utils/const";
import React from "react";
import { FormattedMessage } from "react-intl";
import Media from "react-media";

const HelpAndLearningHeader = ({ history, id }) => (
  <React.Fragment>
    <Media
      query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
      render={() => (
        <div className="help-and-learning__header">
          <div className="help-and-learning__header__title">
            <BackButton
              className="title__back"
              history={history}
              mobile={true}
            />
            <FormattedMessage tagName="span" id={id} />
            <div />
          </div>
        </div>
      )}
    />
    <Media
      query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
      render={() => (
        <div className="help-and-learning__header">
          <div className="help-and-learning__header__title">
            <BackButton className="title__back" history={history} />
            <FormattedMessage tagName="span" id={id} />
            <div />
          </div>
        </div>
      )}
    />
  </React.Fragment>
);

export default HelpAndLearningHeader;
